import { render } from "./WarningSellersTable.vue?vue&type=template&id=d5588d60&scoped=true"
import script from "./WarningSellersTable.vue?vue&type=script&lang=js"
export * from "./WarningSellersTable.vue?vue&type=script&lang=js"

import "./WarningSellersTable.vue?vue&type=style&index=0&id=d5588d60&lang=scss&scoped=true"
import "./WarningSellersTable.vue?vue&type=style&index=1&id=d5588d60&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5588d60"]])

export default __exports__